import { ModalRoot } from './Root'
import { ModalContent } from './Content'
import { ModalFooter } from './Footer'
import { ModalHeader } from './Header'
import { ModalIcon } from './Icon'

export const Modal = {
  Root: ModalRoot,
  Icon: ModalIcon,
  Header: ModalHeader,
  Content: ModalContent,
  Footer: ModalFooter,
}
